module.exports = __webpack_public_path__ + "img/HTC_Asset_28.49e7bbad.png";